import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Download } from "lucide-react";

const PWAInstallButton: React.FC = () => {
  const [showButton, setShowButton] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    // Kiểm tra thiết bị di động
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    
    // Kiểm tra nếu ứng dụng đã được cài đặt dưới dạng PWA
    const isRunningAsPWA = window.matchMedia('(display-mode: standalone)').matches || 
                          (window.navigator as any).standalone === true;
    
    // Chỉ hiển thị button khi người dùng đang sử dụng mobile và KHÔNG đang chạy ứng dụng dưới dạng PWA
    setShowButton(isMobile && !isRunningAsPWA);
  }, []);

  const handleInstallClick = () => {
    navigate("/install-app");
  };

  if (!showButton) return null;

  return (
    <button
      onClick={handleInstallClick}
      className="fixed bottom-20 right-4 z-50 bg-blue-500 hover:bg-blue-600 text-white p-3 rounded-full shadow-lg flex items-center justify-center"
      aria-label={t("installApp", "Cài đặt ứng dụng")}
    >
      <Download className="h-6 w-6" />
    </button>
  );
};

export default PWAInstallButton; 